<template>
  <a-table table-layout="fixed" :show-header="false" :pagination="false" :columns="columns" size="middle" :data-source="tableData" row-key="id">
    <div slot="avatar" slot-scope="text, record" style="position: relative">
      <a-avatar shape="square" :size="48" icon="user" :src="record.creator.avatar_url" class="table-image" />
      <div v-if="record.template_level === 2" class="ribbon-wrapper">
        <div class="ribbon ribbon-pre">DEMO</div>
      </div>
      <div v-if="record.template_level === 3" class="ribbon-wrapper">
        <div class="ribbon ribbon-prod">PROD</div>
      </div>
    </div>
    <span slot="titleCreator" slot-scope="text, record">
      <span class="workflow-value">
        标题:
        <a-tooltip v-if="![0, null].includes(record.parent_id)" placement="top" title="流程已被关联">
          <a-icon type="star" theme="filled" class="is_relation" />
        </a-tooltip>
        <a class="custom-link" :href="getDetailLink(record)" target="_blank">{{ record.title }}</a>
      </span>
      <span class="workflow-value">模板: {{ record.template_name }}</span>
    </span>
    <span slot="templateType" slot-scope="text, record">
      <span class="workflow-value">类型: {{ record.workflow_type.label }}</span>
      <span class="workflow-value">创建人: <user-profiles :value="[record.creator.id]" /></span>
    </span>
    <span slot="statusStep" slot-scope="text, record">
      <span class="workflow-value">当前状态: <a-badge :status="workflowStatus[record.status.value].status" :text="workflowStatus[record.status.value].label" /> </span>
      <span class="workflow-value">当前步骤: {{ record.step_name }}</span>
    </span>
    <span slot="time" slot-scope="text, record">
      <span class="workflow-value">创建时间: {{ record.created_time }}</span>
      <span class="workflow-value">更新时间: {{ record.updated_time }}</span>
    </span>
    <span slot="progress" slot-scope="text, record">
      <a-progress :percent="record.progress" type="circle" :status="record.status.value === 3 ? 'exception' : null" :width="50" :stroke-width="11" stroke-linecap="round" />
    </span>
  </a-table>
</template>

<script>
import { workflowStatus } from '@/utils/dictionary';

const columns = [
  {
    title: '头像',
    width: 60,
    align: 'center',
    scopedSlots: { customRender: 'avatar' }
  },
  {
    ellipsis: true,
    scopedSlots: { customRender: 'titleCreator' }
  },
  {
    width: '12%',
    scopedSlots: { customRender: 'templateType' }
  },
  {
    width: '14%',
    scopedSlots: { customRender: 'statusStep' }
  },
  {
    align: 'center',
    width: '20%',
    scopedSlots: { customRender: 'time' }
  },
  {
    align: 'center',
    width: '5%',
    scopedSlots: { customRender: 'progress' }
  }
];
export default {
  name: 'Workflow',
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      workflowStatus
    };
  },
  methods: {
    // 获取工作流详情链接
    getDetailLink(record) {
      const route = this.$router.resolve({
        name: 'page:project:workflow:detail',
        query: { workflowId: record.id }
      });
      return route.href;
    },
    onDetail(record) {
      this.$router.push({
        name: 'page:project:workflow:detail',
        query: { workflowId: record.id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.workflow-lable {
  max-width: 68px;
  line-height: 24px;
  text-align: right;
  display: inline-block;
}

.workflow-value {
  line-height: 24px;
  width: 100%;
  display: block;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis;
  /* 当对象内文本溢出时显示省略标记(...) ；
                                 需与 overflow:hidden;一起使用。*/
}

.workflow-stop-button {
  color: #ff4d4f;
}

.custom-link {
  color: rgba(0, 0, 0, 0.65);
}

.custom-link:hover {
  color: #1890ff;
}

.ribbon-wrapper {
  width: 54px;
  height: 54px;
  overflow: hidden;
  position: absolute;
  top: -4px;
  left: -4px;

  .ribbon {
    font: bold 12px Sans-Serif;
    line-height: 12px;
    color: #333;
    text-align: center;
    text-transform: uppercase;
    transform: rotate(-45deg);
    position: relative;
    padding: 3px 8px;
    left: -17px;
    top: 9px;
    width: 70px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.5px;
    outline: 1px solid #fff;
    outline-offset: -2px;
  }

  .ribbon-prod {
    background-color: orange;
    color: #fff;
  }

  .ribbon-pre {
    background-color: #2db7f5;
    color: #fff;
  }
}

.is_relation {
  color: orange;
  margin-right: 2px;
}

/deep/.ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
  padding: 8px;
}
</style>
